import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { OfflineModeService } from '../../../../../services/offline-mode.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { BackgroundImageDirective } from '../../../../../directives/background-image.directive';
import { BookInfoComponent } from '../../../../utils/book-info/book-info.component';
import {
    EditionsDropdownComponent
} from '../../../../topbar/edition-switcher/edition-switcher-modal-content/editions-dropdown/editions-dropdown.component';

@Component({
    selector: 'app-about-this-book-modal',
    templateUrl: './about-this-book-modal.component.html',
    styleUrls: ['./about-this-book-modal.component.scss'],
    imports: [
        AssetPipe,
        BackgroundImageDirective,
        BookInfoComponent,
        EditionsDropdownComponent
    ],
    standalone: true
})
export class AboutThisBookModalComponent extends ModalComponent {
    static MODAL_ID = 'aboutThisBookModal';

    constructor(public applicationStateService: ApplicationStateService,
                private offlineModeService: OfflineModeService) {
        super();
    }

    getId(): string {
        return AboutThisBookModalComponent.MODAL_ID;
    }

    /**
     * Creates an offline version of the book
     */
    createOfflineVersion(): void {
        if (this.applicationStateService.bookConfig.offlineVersionCreatable) {
            this.offlineModeService.getOfflineVersion();
        }
    }
}
